import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ToastService } from "./toast.service";
import { CityType, TransportType } from "../_components/transporteur/transporteur.component";

@Injectable()
  
export class TransporteurService {
  private base_url = `${environment.API_URL}/transporteurs`;
  private single_url = `${environment.API_URL}/transporteur`;

  private token = localStorage.getItem("token");
  private headers = new HttpHeaders().set("Authorization", `${this.token}`);

  constructor(private http: HttpClient, private toast: ToastService) {}

  saveTransporteurData(data: {
    departure: CityType,
    arrival: CityType,
    quantity: string[],
    vehicleType: string[],
    days: string[],
    company_id: string,
    distance: string,
  }) {
    return this.http.post(this.single_url, data, { headers: this.headers })
    .map((res)=> JSON.parse(JSON.stringify(res)));
  }

  getTransportsList(params:any = {}) {
    return this.http.post(this.base_url+'/list', params, { headers: this.headers })
    .map((res) => JSON.parse(JSON.stringify(res)));
  }

  getCountries() {
    return this.http.get(this.base_url+'/countries', { headers: this.headers })
    .map((res) => JSON.parse(JSON.stringify(res)));
  
  }
  updateTransport(id: number, transporteurData: TransportType) {
    return this.http.put(`${this.single_url}/${id}`, transporteurData, { headers: this.headers })
    .map((res) => JSON.parse(JSON.stringify(res)));
  }
  deleteTransport(id: number) {
    return this.http.delete(`${this.single_url}/${id}`, { headers: this.headers })
    .map((res) => JSON.parse(JSON.stringify(res)));
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_services/transporteur.service.ts